import React, { FC, Dispatch, SetStateAction } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import RadioButtonsDesktop from './RadioButtonsDesktop';
import RadioButtonsMobile from './RadioButtonsMobile';

interface RadioGroupProps {
  label?: string;
  radioOptions: any[];
  value: any;
  setValue: Dispatch<SetStateAction<any>>;
}

const RadioGroup: FC<RadioGroupProps> = (props) => {
  let { label, radioOptions, value, setValue } = props;

  let mdRadioAreaSize = 12;
  if (label) mdRadioAreaSize = 8;

  return (
    <Grid container style={{ display: 'flex', alignItems: 'center' }}>
      {label && (
        <Grid item xs={12} md={4}>
          <Typography>{label}</Typography>
        </Grid>
      )}
      {window.innerWidth > 500 ? (
        <Grid item xs={12} md={mdRadioAreaSize}>
          <RadioButtonsDesktop radioOptions={radioOptions} value={value} setValue={setValue} />
        </Grid>
      ) : (
        <Grid item xs={12}>
          <RadioButtonsMobile radioOptions={radioOptions} value={value} setValue={setValue} />
        </Grid>
      )}
    </Grid>
  );
};

export default RadioGroup;
